import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import ShoppingMall from '@/views/ShoppingMall'
import User from '@/views/User'
import Integral from '@/views/Integral'
import Expect from '@/views/Expect'
import GetRules from '@/views/GetRules'
import Rquipment from '@/views/Rquipment'
import UploadImg from '@/views/UploadImg'
import UploadImg2 from '@/views/UploadImg2'
import UserInformation from '@/views/UserInformation'
import AfterSale from '@/views/AfterSale'
import ThreeServices from '@/views/ThreeServices'
import Optician from '@/views/Optician'
import CommonProblem from '@/views/CommonProblem'
import Maintain from '@/views/Maintain'
import NoEquipment from '@/views/NoEquipment'
import GZHInstructions from '@/views/GZHInstructions'
import AboutUs from '@/views/AboutUs'
import LeavingMessage from '@/views/LeavingMessage'
import InstructionForUse from '@/views/InstructionForUse'
import CustomerService from '@/views/CustomerService'
import NoCustomerService from '@/views/NoCustomerService'
import Eye from '@/views/Eye'
import Myopia from '@/views/Myopia'
import ShareQRcode from '@/views/ShareQRcode'
import NewUser from '@/views/NewUser'
import SeeUser from '@/views/SeeUser'
import SeeEyeHealth from '@/views/SeeEyeHealth'
import NewFiles from '@/views/NewFiles'
import ModifyFiles from '@/views/ModifyFiles'
import VisionReport from '@/views/VisionReport'
import SchoolPage from '@/views/second/SchoolPage'
import ListOfReports from '@/views/second/ListOfReports'
import StudentDetails from '@/views/second/StudentDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/ShoppingMall',
      name: 'ShoppingMall',
      component: ShoppingMall
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/Integral',
      name: 'Integral',
      component: Integral
    },
    {
      path: '/Expect',
      name: 'Expect',
      component: Expect
    },
    {
      path: '/GetRules',
      name: 'GetRules',
      component: GetRules
    },
    {
      path: '/Rquipment', //设备管理
      name: 'Rquipment',
      component: Rquipment
    },
   /* {
      path: '/Rquipment/UploadImg/:id',
      name: 'UploadImg',
      component: UploadImg
    },*/
    {
      path: '/Rquipment/UploadImg2/:id',
      name: 'UploadImg2',
      component: UploadImg2
    },
    {
      path: '/Rquipment/ShareQRcode/:instrumentId',
      name: 'ShareQRcode',
      component: ShareQRcode
    },
    {
      path: '/UserInformation',
      name: 'UserInformation',
      component: UserInformation
    },
    {
      path: '/UserInformation/NewUser',
      name: 'NewUser',
      component: NewUser
    },
    {
      path: '/UserInformation/SeeUser',
      name: 'SeeUser',
      component: SeeUser
    },
    {
      path: '/UserInformation/SeeEyeHealth/:myfilename/:myfileid',
      name: 'SeeEyeHealth',
      component: SeeEyeHealth,
    },
    {
      path: '/UserInformation/SeeEyeHealth/NewFiles/:myfileid',
      name: 'NewFiles',
      component: NewFiles,
    },
    {
      path: '/UserInformation/SeeEyeHealth/ModifyFiles',
      name: 'ModifyFiles',
      component: ModifyFiles,
    },
    {
      path: '/AfterSale',
      name: 'AfterSale',
      component: AfterSale,
    },
    {
      path: '/AfterSale/CommonProblem',
      name: 'CommonProblem',
      component: CommonProblem
    },
    {
      path: '/AfterSale/CommonProblem/Maintain',
      name: 'Maintain',
      component: Maintain
    },
    {
      path: '/AfterSale/CommonProblem/NoEquipment',
      name: 'NoEquipment',
      component: NoEquipment
    },
    {
      path: '/AfterSale/GZHInstructions',
      name: 'GZHInstructions',
      component: GZHInstructions
    },
    {
      path: '/AfterSale/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/AfterSale/LeavingMessage',
      name: 'LeavingMessage',
      component: LeavingMessage
    },
    {
      path: '/AfterSale/InstructionForUse',
      name: 'InstructionForUse',
      component: InstructionForUse
    },
    {
      path: '/AfterSale/CustomerService',
      name: 'CustomerService',
      component: CustomerService
    },
    {
      path: '/AfterSale/NoCustomerService',
      name: 'NoCustomerService',
      component: NoCustomerService
    },
    {
      path: '/ThreeServices',
      name: 'ThreeServices',
      component: ThreeServices
    },
    {
      path: '/ThreeServices/Eye',
      name: 'Eye',
      component: Eye
    },
    {
      path: '/ThreeServices/Myopia',
      name: 'Myopia',
      component: Myopia
    },
    {
      path: '/ThreeServices/Optician',
      name: 'Optician',
      component: Optician
    },
    // 报告-----二期
    {
      path: '/VisionReport',
      name: 'VisionReport',
      component: VisionReport
    },
    {
      path: '/VisionReport/SchoolPage/:cname',
      name: 'SchoolPage',
      component: SchoolPage
    },
    {
      path: '/VisionReport/ListOfReports/:gradeName/:ft/:et/:className',
      name: 'ListOfReports',
      component: ListOfReports,
      // meta: {
      //   title: '中关村第二小学',
      // }
    },
    {
      path: '/VisionReport/StudentDetails/:gradeName/:ft/:et/:className/:statusid',
      name: 'StudentDetails',
      component: StudentDetails,
      // meta: {
      //   title: '学生个人使用详情',
      // }
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js